import type { Modifier } from '@popperjs/core'
const maxMobileWidth = 450 // this must hive with width in filterConstants.scss

/**
 * This modifier is used to make the filter full screen for mobile (< maxMobileWidth).
 *
 * A "modifier" is a plugin that can be used to modify the behavior of the popper.
 * In this case in particular, we are modifying the popper to be full screen on mobile,
 * by adjusting the height, width and transform of the popper.  The 10px adjustment is
 * to account for the top margin on the filter which is typically use as a gap between
 * the popup and the trigger.
 *
 * See https://popper.js.org/docs/v2/modifiers/ for more on how these work.
 */
const fullScreenModifier: Modifier<'fullScreen', Record<string, never>> = {
  name: 'fullScreen',
  enabled: true,
  phase: 'beforeWrite',
  fn({ state }) {
    const viewPort: Partial<VisualViewport> = state.scrollParents.popper[1]
    const viewHeight = viewPort.height
    const viewWidth = viewPort.width
    if (viewHeight && viewWidth && viewWidth < maxMobileWidth) {
      state.styles.popper.transform = 'translate(0px, -10px)'
      state.styles.popper.height = `${viewHeight + 20}px`
      state.styles.popper.width = '100%'
    } else {
      delete state.styles.popper.height
    }
  },
}

export { fullScreenModifier }
